/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_What_TitleInputs */

const en_home_what_title = /** @type {(inputs: Home_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is CADCraft?`)
};

/**
* | output |
* | --- |
* | "What is CADCraft?" |
*
* @param {Home_What_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_what_title = /** @type {((inputs?: Home_What_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_What_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_what_title(inputs)
});
export { home_what_title as "home.what.title" }